import { render, staticRenderFns } from "./Podcasts.vue?vue&type=template&id=aef53516&scoped=true"
import script from "./Podcasts.vue?vue&type=script&lang=js"
export * from "./Podcasts.vue?vue&type=script&lang=js"
import style0 from "./Podcasts.vue?vue&type=style&index=0&id=aef53516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef53516",
  null
  
)

export default component.exports